
    function getEmailByDistributor(distributor) {
        switch (distributor) {
          case "Aurora Beauty Supply":
              return "Venessa@aurorabeautyak.com";
          case "Beauty Craft":
              return "meghanm@beautycraft.com";
          case "Cosmo Prof":
              return "kswick@sallybeauty.com";
          case "Goldwell New York":
              return "mhaight@goldwellny.com";
          case "Hair-Lines":
              return "jessjpms@hotmail.com";
          case "MAKA Beauty Systems":
              return "MichelleK@makabeauty.com";
          case "ManocoBlue":
              return "mhooker@manocoblue.com";
          case "Paramount Beauty Distributors":
              return "erin@paramountbeauty.com";
          case "Prestige Salon Products":
              return "rhonda@prestigesalonproducts.com";
          case "SalonCentric":
              return "tcarroll@saloncentric.com";
          case "Salon Service Group":
              return "brandstrategists@salonservicegroup.com";
          case "Salon Services Pro":
              return "cdaniels@salonservicespro.com";
          case "State Beauty/RDA Pro Mart":
              return "tdavidson@saloncentric.com";
          case "TruBeauty Concepts":
              return "myrta@trubeautyconcepts.com";
          default:
              return "";
          }
    }
    function validateForm() {
        const tabs = document.getElementsByClassName("tab");
        const requiredFields = tabs[currentTab].querySelectorAll("[required]");
        const passwordInput = document.getElementById("password");
        const confirmPasswordInput = document.getElementById("confirmPassword");
        const confirmPasswordError = document.getElementById("confirmPasswordError");
        const passwordError = document.getElementById("passwordError");
        let valid = true;

        const termsCheckbox = document.querySelector("[data-terms-field]");
        const submitButton = document.getElementById("submitBtn");
        const nextButton = document.getElementById("nextBtn");
        const salonName = document.getElementById("salon_name");
        const salonNameError = document.getElementById("salonNameError");
        const phoneNumberInput = document.getElementById('phone');
        const phoneNumberError = document.getElementById('phoneError');
        let phoneNumber = phoneNumberInput.value.trim();

        // const accountNumberFields = tabs[currentTab].querySelector('#account_number');
        const accountNumberInput = document.querySelector('#account_number');
        const accountNumberError = document.getElementById('accountNumberError');
        let accountNumber = accountNumberInput.value.trim();

        const emailInput = document.getElementById("emailMain");
        const emailError = document.getElementById("emailError");
        let emailValue = emailInput.value;
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        const zipCodes = tabs[currentTab].querySelector("#zip");
        const zipInput = document.getElementById("zip");
        const zipError = document.getElementById("zipError");
        let zipValue = emailInput.value;

        const passwordPattern = /^.{8,50}$/;
        const textFieldPattern = /^[A-Za-z ]{2,50}$/

        const isSuit = document.getElementById('isSuit');

        const distributorSelect =document.getElementById('distributorName');
        const distributorError = document.getElementById('distributorNameError');

        const uploadFileFields = tabs[currentTab].querySelector('#isSuit');
        const uploadImage = document.querySelector("[ data-upload-image]");
        const fileInput = document.getElementById('file-input');

        function isSubmitButtonEnabled() {
            return (
                termsCheckbox.checked &&
                valid &&
                distributorSelect.value !== '' &&
                (
                    (isSuit.value === 'false' && accountNumberInput.value !== '') ||
                    (isSuit.value === 'true' && fileInput.files.length > 0 && accountNumberInput.value !== '')
                )
            );
        }

        termsCheckbox.addEventListener('change', function () {
            if (distributorSelect.value === '') {
                distributorError.textContent = "Please select a distributor";
                distributorError.style.display = 'block';
                termsCheckbox.checked = false;
                valid = false;
            } else if (accountNumberInput.value === '') {
                accountNumberError.textContent = "Please type account number";
                accountNumberError.style.display = 'block';
                termsCheckbox.checked = false;
                valid = false;
                submitButton.disabled = true;;
            }else if(!termsCheckbox.checked) {
                submitButton.disabled = true;
            } else if (isSubmitButtonEnabled()) {
                submitButton.disabled = false;
            }
        });

        function validateZipCode(zipCode) {
            const zipPatternUSA = '/^\(\d{3}\)\s\d{3}-\d{4}$/';
            const zipPatternCanada =  '/^(\+?1\s?)?(\()?(\d{3})(?(2)\))[-.\s]?(\d{3})[-.\s]?(\d{4})$/';

            return zipPatternUSA.test(zipCode) || zipPatternCanada.test(zipCode);
        }

        function validateAccountNumber(accountNumber) {
            const patternNumber = '/^.{3,50}$/';
            return patternNumber.test(accountNumber);
        }

        function checkFormValidity() {
            valid = true;

            requiredFields.forEach(function (field) {
                if (field.value === "") {
                    field.classList.add("invalid");
                    valid = false;
                    field.nextElementSibling.textContent = "Empty value";
                } else if( field.value.length < 2) {
                    field.classList.add("invalid");
                    valid = false;
                    field.nextElementSibling.textContent = "Text must be at least 2 characters";
                }else {
                    field.classList.remove("invalid");
                    field.nextElementSibling.textContent = "";
                }
            });

            // Phone validation
            if (phoneNumber !== '' && !validatePhoneNumber(phoneNumber) ) {
                phoneNumberError.style.display = 'block';
                phoneNumberError.textContent = "Incorrect phone number";
                phoneNumberInput.classList.add('invalid');
                valid = false;
            } else {
                phoneNumberError.style.display = 'none';
                phoneNumberError.textContent = "";
                phoneNumberInput.classList.remove('invalid');
            }

            if (!emailPattern.test(emailValue)) {
                emailError.textContent = "Invalid email format";
                emailError.style.display = 'block';
                emailInput.classList.add("invalid");
                valid = false;
            } else {
                emailError.textContent = "";
                emailError.style.display = 'none';
                emailInput.classList.remove("invalid");
            }

            // Password validation
            if (!passwordPattern.test(passwordInput.value)) {
                passwordError.textContent = "Password must be at least 8 characters";
                valid = false;
            } else if (passwordInput.value !== confirmPasswordInput.value) {
                confirmPasswordError.textContent = "Passwords do not match";
                valid = false;
            } else {
                passwordError.textContent = "";
                confirmPasswordError.textContent = "";
            }

            // Zip Code validation
            if (zipCodes === !null) {

                if (!validateZipCode(zipValue)) {
                    zipError.textContent = "Invalid zip code format";
                    zipError.style.display = 'block';
                    zipInput.classList.add("invalid");
                    valid = false;
                } else {
                    zipError.textContent = "";
                    zipError.style.display = 'none';
                    zipInput.classList.remove("invalid");
                }
            }
        }

        function handleInputChange(event) {
          if (event) {
            const target = event.target;
            const targetId = target.getAttribute("id");

            if (targetId === "email") {
                emailValue = target.value;
            } else if (targetId === "phone") {
                phoneNumber = target.value;
            } else if (targetId === "account_number") {
                accountNumber = target.value;
            } else if (targetId === "zip") {
                zipValue = target.value;
            }
          }
          checkFormValidity();
        }

        requiredFields.forEach(function (field) {
            if (field.tagName.toLowerCase() === 'select') {
                field.addEventListener('change', checkFormValidity);
            } else {
                field.addEventListener('input', handleInputChange);
            }
        });

        emailInput.addEventListener('input', handleInputChange);
        phoneNumberInput.addEventListener('input', handleInputChange);
        passwordInput.addEventListener('input', handleInputChange);
        confirmPasswordInput.addEventListener('input', handleInputChange);
        termsCheckbox.addEventListener('change', checkFormValidity);
        zipInput.addEventListener('change', checkFormValidity);

        distributorSelect?.addEventListener('change', function () {
            distributorError.textContent = '';
            checkFormValidity();
        });

        accountNumberInput?.addEventListener('input', function (event) {
            accountNumberError.textContent = '';
            let accountNumberValue = event.target.value.trim();

            if (termsCheckbox.checked) {
                termsCheckbox.checked = false;
                submitButton.disabled = true;
            }
            handleInputChange();
            if (!validateAccountNumber(accountNumberValue)) {
                accountNumberError.style.display = 'block';
                accountNumberError.textContent = "Incorrect account number";
                accountNumberInput.classList.add('invalid');
                valid = false;
            } else {
                accountNumberError.style.display = 'none';
                accountNumberError.textContent = "";
                accountNumberInput.classList.remove('invalid');
                valid = true;
                termsCheckbox.checked = false;
            }
        });

        isSuit.addEventListener('change', function () {
            if (termsCheckbox.checked) {
                termsCheckbox.checked = false;
            }
            submitButton.disabled = true;
            checkFormValidity();
        });

        fileInput.addEventListener('change', checkFormValidity);
        checkFormValidity();
        return valid;
    }

    function validatePhoneNumber(phoneNumber) {
        const phonePattern = /^\d{10}$/;
        return phonePattern.test(phoneNumber.replace(/\s/g, ''));;
    }

    // Upload function
    function imagePreview() {
        const fileField = document.getElementById("file-input");
        const labelText = document.querySelector("[data-upload-text]");
        const labelRemove = document.querySelector("[data-remove-img]");
        const uploadWrap = document.querySelector("[data-upload-file]");
        const uploadImageWrap = document.querySelector("[ data-upload-image-wrap]");
        const labelDefault = labelText.textContent;
        const preview = document.getElementById("preview");

        const termsCheckBox = document.querySelector("[data-terms-field]");
        termsCheckBox.checked = false;

        // on file change
        // file.addEventListener("change", (event) => {
        const file = fileField.files[0];
        const allowedTypes = ['image/jpeg', 'image/jpg', 'application/pdf', 'image/png'];

        // Перевірити, чи вибраний файл і його розмір не перевищує 5 МБ
        if (file && file.size > 5 * 1024 * 1024) {
            alert('Розмір файлу перевищує максимально допустимий розмір (5 МБ). Будь ласка, виберіть файл меншого розміру.');
            // Очистити значення елемента вводу файлу (необов'язково)
            fileField.value = '';
        }
        if (allowedTypes.includes(file.type)) {
            const fileName = fileField.value.split("\\").pop();
            if (fileName) {
                labelText.textContent = fileName;
                labelRemove.style.display = "flex";
                preview.style.display = "block";

                if (file.type === "application/pdf") {
                    uploadImageWrap.style.display = "none";
                    uploadWrap.style.display = "none";
                } else {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        preview.setAttribute("src", e.target.result);
                        uploadWrap.style.display = "none";
                        uploadImageWrap.style.display = "block";
                    };
                    reader.readAsDataURL(file);
                }
            } else {
                labelText.textContent = labelDefault;
                labelRemove.style.display = "none";
                preview.style.display = "none";
                uploadWrap.style.display = "block";
            }
        }
        // });
    }

    // Remove file
    function removePreview() {
        const fileField = document.getElementById("file-input");
        const file = fileField.files[0];
        const labelText = document.querySelector("[data-upload-text]");
        const labelRemove = document.querySelector("[data-remove-img]");
        const uploadWrap = document.querySelector("[data-upload-file]");
        const submitBtn = document.querySelector("#submitBtn");
        const termsCheckBox = document.querySelector("[data-terms-field]");
        const preview = document.getElementById("preview");
        const labelDefault = labelText.textContent;
        const isSuit = document.getElementById('isSuit');

        fileField.value = '';
        labelText.textContent = labelDefault;
        labelRemove.style.display = "none";
        preview.style.display = "none";
        uploadWrap.style.display = "block";
        submitBtn.disabled = true;
        termsCheckBox.checked = false;
    }

    document.addEventListener('DOMContentLoaded', (event) => {

    const countrySelect = document.getElementById('country');
    const stateSelect = document.getElementById('state');
    const citySelect = document.getElementById('city');
    const zipField = document.getElementById('zip');

    citySelect.disabled = true;
    zipField.disabled = true;

    stateSelect.addEventListener('change', () => {
        citySelect.disabled = false;
        zipField.disabled = false;
    });
})

    // Show or hide the image upload value

    function toggleDivVisibility() {
        const selectBox = document.querySelectorAll('[data-upload-image]')[0];
        const uoploadBlock = document.querySelectorAll('[data-upload-image-block]')[0];
        const selectedValue = selectBox.value;

        if (selectedValue === 'true') {
            uoploadBlock.style.display = 'block';
        } else {
            uoploadBlock.style.display = 'none';
        }
    }

    function showSpinner() {
        const spinner = document.querySelector('[data-spinner-wrap]');
        const popups = document.querySelectorAll('.tingle-modal-box');
        popups.forEach(popup => popup.style.overflow = 'hidden');
        spinner.style.display = 'block';
    }

    function hideSpinner() {
        const spinner = document.querySelector('[data-spinner-wrap]');
        const popups = document.querySelectorAll('.tingle-modal-box');
        popups.forEach(popup => popup.style.overflow = 'auto');
        spinner.style.display = 'none';
    }

    function formResize(size) {
        const popups = document.querySelectorAll('.ac-popup');
        popups.forEach(popup => {
            if (size === "lg") {
                popup.classList.add('ac-popup--lg');
                popup.classList.remove('ac-popup--sm');
            } else if (size === "sm") {
                popup.classList.add('ac-popup--sm');
                popup.classList.remove('ac-popup--lg');
            } else {
                popup.classList.add('ac-popup--md');
                popup.classList.remove('ac-popup--lg');
                popup.classList.remove('ac-popup--sm');
            }
        });
    }

    // start Auth
    const secretCode = "6Qhc6yjh5C6BrKZGR924KhizR528B2iEjzqTHHxnvtXka552uJ";

    function generateToken(body, secretCode){
        const email = { email: body.customer.email };
        const jsonEmail = JSON.stringify(email);
        const salt = generateSecretSalt(jsonEmail, secretCode);
        const ab =   jsonEmail + salt;
        const hash = CryptoJS.SHA256(ab);
        const encodedHash = CryptoJS.enc.Hex.stringify(hash);
        const result = {
            payload: email,
            signature: encodedHash
        };
        return toBase64(JSON.stringify(result));
    }

    function generateSecretSalt(jsonEmail, secretCode){
        return toBase64(jsonEmail + secretCode);
    }

    function toBase64(body) {
        const base64 = btoa(body);
        return base64;
    }
    // end Auth

    function submitForm(event) {
        const form = document.getElementById('create_customer');

        event.preventDefault(); // Stop the default form submission
        validateForm();
        const fileInput = document.getElementById('file-input');
        const isSuit = document.getElementById('isSuit');
        const phoneNumber = form.phone.value.replace(/-/g, '').trim(); // and remove dashes
        const distributorEmail = getEmailByDistributor(form.distributorName.value);
        let phoneWithCountryCode = "";
        if (phoneNumber !== "") {
            phoneWithCountryCode = "+1" + phoneNumber; // If the phone number is not empty, add "+1" .
        } else {
            phoneWithCountryCode = phoneNumber; // If the phone number is empty, leave it as is.
        }

        const formData = {
            customer: {
                first_name: form.firstName.value,
                last_name: form.last_name.value,
                email: form.email.value,
                account_number:  form.account_number.value.replace(/-/g, ''),
                password: form.password.value,
                password_confirmation: form.confirmPassword.value,
                phone: phoneWithCountryCode.replace(/ /g, ''),
                salon_name: form.salon_name.value,
                distributor_name: form.distributorName.value,
                distributor_email: distributorEmail,
                is_suit: form.isSuit.value,
                subscribe: form.subscribe.checked,
                addresses: [{
                    salon_address: form.salon_address.value,
                    salon_address2: form.salon_address2.value,
                    country: form.country.value.toUpperCase(),
                    state: form.province.value,
                    city: form.city.value,
                    zip: form.zip.value
                }]
            }
        };

        const token = generateToken(formData, secretCode);
        showSpinner();
        fetch(`https://cbb5e9xp3a.execute-api.us-east-1.amazonaws.com/auth/registration`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': token,
            },
            body: JSON.stringify(formData)
        })
            .then(response => response.json())
            .then(response => {
                if (response.success) {
                    if (isSuit.value === 'true' && fileInput.files.length > 0) {
                        const file = fileInput.files[0];
                        const validateFileName = file.name.replace(/[\/+&\\]/g, '_');
                        const fileName = btoa(form.email.value) + '&' + validateFileName;
                        const uploadUrl = `https://nrn4n1ioml.execute-api.us-east-1.amazonaws.com/auth/suits-images/${fileName}`;

                        return fetch(uploadUrl, {
                            method: "POST",
                            headers: { 
                              "Content-Type": "multipart/form-data"
                            },
                            body: file
                        })
                            .then(function(response) {
                                if (response.status === 200) {
                                    console.log('Response success');
                                    window.showSuccessForm();
                                    hideSpinner();
                                } else {
                                    hideSpinner();
                                    alert('Image not uploaded.'); // Calling a function to display a message about the unloaded image.
                                }
                            })
                            .catch(function(error) {
                                hideSpinner();
                                window.showSuccessForm();
                                console.error('Error:', error); // Handling errors during request execution.
                            });
                    } else if (response.success){
                        //  If successful, but image upload is not required, perform the necessary actions.
                        // ...
                        console.log('If successful but image loading is not required, perform the necessary actions.');
                        window.showSuccessForm();
                        hideSpinner();
                        return Promise.resolve();
                    }
                    else {
                        console.log('fieldName', response.errors[0].field_name);
                        console.log('error_message', response.errors[0].error_message);
                        hideSpinner();
                        window.hideRecoverPasswordForm();
                    }
                    // Success response
                    hideSpinner();
                    window.showSuccessForm();
                    console.log('Form submitted successfully');
                } else {
                    // Error response
                    console.log('Form submission error:', response.error_message);
                    hideSpinner();

                    const responseErrors = response.errors

                    console.log('responseErrors', responseErrors)

                    responseErrors.forEach(function(error) {
                        const fieldId = error.field_name;
                        const errorMessage = error.error_message;
                        if (fieldId == 'email') {
                            window.nextPrev(-2);
                            const fieldElement = document.getElementById('email');
                            const errorElement = document.getElementById('emailError');
                            fieldElement.classList.add("invalid");
                            errorElement.style.display = "block";
                            errorElement.textContent = errorMessage;
                        } else if (fieldId == 'account_number') {
                            const fieldElement = document.getElementById('account_number');
                            const errorElement = document.getElementById('accountNumberError');
                            fieldElement.classList.add("invalid");
                            errorElement.style.display = "block";
                            errorElement.textContent = errorMessage;
                        } else{
                            window.nextPrev(-2);
                            const fieldElement = document.getElementById(fieldId);
                            const errorElement = document.getElementById(`${fieldId}Error`);
                            fieldElement.classList.add("invalid");
                            errorElement.style.display = "block";
                            errorElement.textContent = errorMessage;
                        }
                    });
                }
        })
          .catch(error => {
              // Error handling
              hideSpinner();
              console.log(error);
          });
    }
